import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  content: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    minHeight: '4.625rem',
    padding: '0.75rem 0.75rem 0.75rem 4.5rem',
    borderRadius: '0.5rem',
    border: `1px solid ${palette.primary.dark}`,
    borderLeftWidth: '0.25rem',
    backgroundColor: palette.common.white,
    '& img': {
      position: 'absolute',
      top: '0.75rem',
      left: '0.75rem',
      width: '3rem',
      height: '3rem',
    },
  },
  text: {
    margin: 0,
  },
}));
